import { createApp } from 'vue'
import store from './store'
import App from './App.vue'
import './assets/main.css'
import router from './router/router'
const app = createApp(App)
app.use(store)
app.use(router)
app.mount("[data-njam-search]");

// filters
app.config.globalProperties.$filters = {
    formatNumber(value) {
        return new Intl.NumberFormat('nl-BE').format(value);
    }
}